const SELECTOR = '[data-checkbox-dependent]';

const SOURCE_SELECTOR = '[data-checkbox-dependent="source"]';
const TARGET_SELECTOR = '[data-checkbox-dependent="target"]';
const ACTIVE_ATTRIBUTE = 'data-checkbox-dependent-active';

const CHECKBOX_SELECTOR = 'input[type="checkbox"]';

class CheckboxDependent {
  constructor() {
    if ($(SELECTOR).size()) {
      this.attachEventHandlers();
    }
  }

  attachEventHandlers() {
    $(SOURCE_SELECTOR)
      .on('change', CHECKBOX_SELECTOR, this.updateTarget)
      .find(CHECKBOX_SELECTOR)
      .trigger('change');
  }

  updateTarget(event) {
    const $this = $(event.currentTarget);
    const reversed = $this.data('checkbox-dependent-reversed');
    const isChecked = reversed ? !$this.is(':checked') : $this.is(':checked');

    $this
      .closest(SOURCE_SELECTOR)
      .attr(ACTIVE_ATTRIBUTE, isChecked)
      .next(TARGET_SELECTOR)
      .attr('disabled', !isChecked); // If this is fieldset, do not send its form controls
  }
}

export default CheckboxDependent;



// WEBPACK FOOTER //
// ./src/javascripts/CheckboxDependent.js